export default "__VITE_ASSET__BpfzKrRh__"